import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "de muis staat op volledig scherm inschakelen"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M21 6v4h-2V6h-4V4h6v2zm-2 13v-4h2v6h-6v-2h4zM6 6v4H4V4h6v2H6zm0 13h4v2H4v-6h2v4z"
})));